import { render, staticRenderFns } from "./LiveBottomAction.vue?vue&type=template&id=47a24c70&scoped=true"
import script from "./LiveBottomAction.vue?vue&type=script&lang=js"
export * from "./LiveBottomAction.vue?vue&type=script&lang=js"
import style0 from "./LiveBottomAction.vue?vue&type=style&index=0&id=47a24c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a24c70",
  null
  
)

export default component.exports